import { FooterNavi } from 'features/footer/api';
import { Feature } from 'libs/features';

interface NaviWithPosition {
  position: number;
  feature: Feature;
}

/**
 * 指定された Feature に対応する FooterNavi を検索し、
 * position 情報付きの NaviWithPosition を作成する。
 * 該当するナビがなければ null を返す。
 */
export const mapFeatureToNavi = (
  feature: Feature,
  footerNavis: FooterNavi[]
): NaviWithPosition | null => {
  const matchedNavi = footerNavis.find((navi) => navi.code === feature.id);
  if (!matchedNavi) {
    return null;
  }

  return {
    position: matchedNavi.position,
    feature: {
      ...feature,
      label: matchedNavi.label || feature.label // labelが設定されていたら置き換える
    }
  };
};

/**
 * フッターナビ設定に基づき、利用可能な Features を position 順に並べ替えて取得する。
 */
export const getSortedVisibleFeatures = (
  features: Feature[],
  footerNavis: FooterNavi[]
): Feature[] => {
  if (footerNavis.length === 0) {
    return features;
  }

  return features
    .map((feature) => mapFeatureToNavi(feature, footerNavis)) // ナビをマッピング
    .filter((navi): navi is NaviWithPosition => navi !== null) // null を除外
    .sort((a, b) => a.position - b.position) // position 順にソート
    .map((navi) => navi.feature); // Feature のみ抽出
};
